import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import Rodal from 'rodal'
import { sanitizeHtml } from '../../../utils/sanitizeHtml'
import dispatchers from 'reduxModules/confirmation/dispatchers'
import stateSelector from 'reduxModules/confirmation/selectors'
import keyUpHandler from '../../utils/keyUpHandler'
import CancelSubscription from '../../Account/CancelSubscription'
import ChangeSubscriptionConfirmation from '../../Account/ChangeSubscription/ChangeSubscriptionConfirmation'
import SelectSubscriptionType from '../../Account/SelectSubscriptionType'
import './styles.css'

export class Confirmation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldBeDisabled: false
    }

    this.changeSubmitButtonStatus = this.changeSubmitButtonStatus.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.resolveFeedback = this.resolveFeedback.bind(this)
  }

  handleClose() {
    if (this.props.cancelCallback)
      this.props.cancelCallback()

    this.props.resolve('reject')
  }

  changeSubmitButtonStatus(shouldBeDisabled) {
    this.setState({ shouldBeDisabled })
  }

  resolveFeedback(resolveValue) {
    return () => {
      this.props.resolve(
        resolveValue, this.renderedChild && this.renderedChild.getResponse()
      )
    }
  }

  render() {
    const { props } = this
    return (
      <Rodal
        className={classnames('confirmation', { [props.componentId]: !!props.componentId })}
        visible
        onClose={this.handleClose}
        height={props.height || 250}
        animation="fade"
        customStyles={{ width: props.isMobile ? '375px' : '527px' }}
      >
        <div className="header"><h2>{props.title}</h2></div>
        {!props.feedback && props.componentId !== 'upgrade' && props.componentId !== 'cancellation' && props.componentId !== 'selection' && (
          <div
            className="body"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.text) }}
          />
        )}
        {props.componentId === 'cancellation' && (
          <CancelSubscription
            ref={(c) => { this.renderedChild = c }}
            {...this.props}
            changeSubmitButtonStatus={this.changeSubmitButtonStatus}
          />
        )}
        {props.componentId === 'selection' && (
          <SelectSubscriptionType
            ref={(c) => { this.renderedChild = c }}
            onClose={this.handleClose}
          />
        )}
        {props.componentId === 'upgrade' && (
          <div className="body">
            <ChangeSubscriptionConfirmation
              ref={(c) => { this.renderedChild = c }}
              {...this.props}
              changeSubmitButtonStatus={this.changeSubmitButtonStatus}
            />
          </div>
        )}
        {props.showButtons && (
          <div className={classnames('buttons', { 'with-feedback': !!props.feedback })}>
            {props.showReject && (
              <button
                type="button"
                className="cancel-btn"
                onClick={this.handleClose}
                onKeyUp={(event) => keyUpHandler(event, this.handleClose)}
                tabIndex={0}
              >
                {props.rejectText || 'Cancel'}
              </button>
            )}
            {props.options && props.options.map((option, optionIndex) => (
              <button
                type="button"
                className={`ctaBtn ${option.class || ''}`}
                disabled={this.state.shouldBeDisabled}
                key={optionIndex}
                onClick={this.resolveFeedback(option.resolveValue)}
                onKeyUp={(event) => keyUpHandler(event, this.resolveFeedback, null, null, [option.resolveValue])}
                tabIndex={0}
              >
                {option.text || 'Accept'}
              </button>
            ))}
          </div>
        )}
      </Rodal>
    )
  }
}

Confirmation.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  rejectText: PropTypes.string,
  showReject: PropTypes.bool,
  showButtons: PropTypes.bool,
  resolve: PropTypes.func,
  cancelCallback: PropTypes.func,
  componentId: PropTypes.string,
  feedback: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      options: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string
      }))
    })
  ]),
  height: PropTypes.number,
  isMobile: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    class: PropTypes.string,
    resolveValue: PropTypes.any
  }))
}

Confirmation.defaultProps = {
  text: '',
  rejectText: 'Cancel',
  showReject: true,
  showButtons: true,
  resolve: () => {},
  cancelCallback: null,
  componentId: '',
  feedback: false,
  height: null,
  isMobile: false,
  options: []
}

export default connect(
  stateSelector,
  dispatchers
)(Confirmation)
